import styled from 'styled-components'

export const Text = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary};
`
export const Title = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`
export const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`
export const RowWrapper = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.primary};
`
export const RowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`
export const GridRowContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`
export const TextRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLite};
`
export const BlockContainer = styled.div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.colors.backgroundLite};
  transition: 0.3s;

  /* background-color: ${({ theme }) => `${theme.colors.secondary}10`}; */
  & > div:last-child {
    border: none;
  }
  &#riskBlock:hover {
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.brand};
    background-color: ${({ theme }) => `${theme.colors.brand}10`};
  }
`
export const InfoTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};

  font-size: 14px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`
export const RiskContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  & #rsSubTitle {
    color: ${({ theme }) => theme.colors.secondary};
  }
`
